import type { ReactNode } from "react";

export interface FloatingSelectProps {
  id: string;
  label: string;
  icon: ReactNode;
  value: string;
  onChange: (e: { target: { value: string } }) => void;
  options: { value: string; label: string; disabled?: boolean }[];
}

export function FloatingSelect({
  id,
  label,
  icon,
  value,
  onChange,
  options,
}: FloatingSelectProps) {
  return (
    <div className="floating-field relative">
      <select
        id={id}
        name={id}
        value={value}
        onChange={onChange}
        className="block w-full appearance-none rounded-xl border border-slate-200 bg-transparent px-4 pb-3 pt-5 text-sm text-slate-900 transition-colors duration-200 focus:border-[#2C78B9] focus:ring-0 focus:shadow-[0_0_0_3px_rgba(44,120,185,0.08)]"
      >
        {options.map((o) => (
          <option key={o.value} value={o.value} disabled={o.disabled}>
            {o.label}
          </option>
        ))}
      </select>
      <label
        htmlFor={id}
        className="inline-flex items-center gap-1.5"
      >
        <span className="w-3.5 h-3.5 flex items-center justify-center">
          {icon}
        </span>
        {label}
      </label>
      <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2">
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-slate-400"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </span>
    </div>
  );
}
